/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type ExportStatus = typeof ExportStatus[keyof typeof ExportStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportStatus = {
  Queued: 'Queued',
  Building: 'Building',
  Ready: 'Ready',
  Failed: 'Failed',
} as const;
